const allStates = $('.usMap__state');

allStates.each(function(index, el) {
    el.addEventListener('click', function() {
        location.href = '/hospice-' + el.getAttribute('data-location-href');
    });
});